const isVDP = dataLayer => dataLayer?.page?.pageName === 'vdp' || dataLayer?.page?.pg === 'fyc_vdp';
const isHybridVDPPage = dataLayer => dataLayer?.page?.pageName === 'inv' || dataLayer?.page?.pg === 'fyc_hybrid_vdp';
export { isVDP, isHybridVDPPage };